(function ($) {

    $('document').ready(function() {
        CustomApp.init();
    });

}(jQuery));

var CustomApp = {

    modal: null,

    init: function()
    {
        var _this = this;
        $('body').on('pageActivated', function() {
            _this.contactForm();
            _this.comments();
            $('video, audio').mediaelementplayer();
        });
    },

    comments: function()
    {
        var respond = window.location.hash.substr(1);

        if (location.hash) {
            setTimeout(function() {
                window.scrollTo(0, 0);
            }, 1);
        }

        if (respond.length > 0) {
            $('.comments-list').slideToggle();
        }

        $('a', '.comments-trigger').on('click', function (e) {
            e.preventDefault();
            $('.comments-list').slideToggle();
        })
    },

    contactForm: function()
    {
        var _this = this;
        var sent = false;

        $('.wpcf7 > form').unbind('submit');
        $('.wpcf7 > form').on('submit', function(e) {
            e.preventDefault();
            window.wpcf7.submit(this);
        });

        $('.wpcf7').on('wpcf7:mailsent', function(data){
            setTimeout(function(e){
                var result = $(data.currentTarget);
                var response = result.find('.screen-reader-response');
                var message = 'Thank you your message has been sent';

                if (response.length > 0) {
                    message = response[0].innerText;
                }

                $('.modal > p').html(message);
                _this.openModal();
            }, 50);
        });

        var $output = $('.wpcf7-response-output');
        $output.insertBefore($output.siblings('.submit'));
    },

    openModal: function()
    {
        CustomApp.modal = $('[data-remodal-id=modal]').remodal({
            'hashTracking' : false
        });

        CustomApp.modal.open();
    }
};